var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowMenuClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D5DDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6146 13.1979L10.6553 13.1979L14.5695 9.28378C14.8823 8.97096 14.8823 8.45763 14.5695 8.14482C14.2567 7.83201 13.7514 7.83201 13.4385 8.14482L8.15282 13.4305C7.84 13.7434 7.84 14.2487 8.15282 14.5615L13.4305 19.8552C13.7433 20.168 14.2487 20.168 14.5615 19.8552C14.8743 19.5424 14.8743 19.0371 14.5615 18.7243L10.6553 14.8021L19.6146 14.8021C20.0557 14.8021 20.4167 14.4412 20.4167 14C20.4167 13.5589 20.0557 13.1979 19.6146 13.1979Z",
    fill: "#D5DDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuClose);
export default __webpack_public_path__ + "static/media/arrow_menu_close.ad1e9b49b97302854bfec5dd2c8fa391.svg";
export { ForwardRef as ReactComponent };